/**
 * PhoneSaleNew — R7a (2026-05-18) — standalone phone-sale create page.
 *
 * Reads optional ?contact_id= query param to prefill (e.g. from the
 * Contact Detail "Log Phone Sale" link path; the QuickActionsSection
 * modal also exists for in-context creation). On success, navigates
 * to the detail page for the new activity.
 */

import React from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import PhoneSaleForm from "../../components/sales-activities/PhoneSaleForm";

const PhoneSaleNew: React.FC = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const lockedContactId = params.get("contact_id") || undefined;

  return (
    <div className="space-y-4">
      <div>
        <Link
          to="/sales-activities/phone-sales"
          className="text-sm text-blue-600 hover:underline"
        >
          ← Back to phone sales
        </Link>
        <h1 className="mt-2 text-2xl font-semibold text-gray-900">
          Log a Phone Sale
        </h1>
        <p className="mt-1 text-sm text-gray-600">
          Records a sale logged over the phone. Idempotent — re-submitting the
          same form returns the existing row instead of creating a duplicate.
        </p>
      </div>

      <div className="max-w-2xl rounded-lg border border-gray-200 bg-white p-6">
        <PhoneSaleForm
          lockedContactId={lockedContactId}
          onSuccess={(id) => navigate(`/sales-activities/phone-sales/${id}`)}
          onCancel={() => navigate("/sales-activities/phone-sales")}
        />
      </div>
    </div>
  );
};

export default PhoneSaleNew;
